export default __webpack_public_path__ + "static/media/id_back.2770793c.png";